<template>
    <div style="height: 100%;">
        <helpInfo :helpData="helpData"></helpInfo>
        <div class="unread-msg">
            <div class="msg-table"
                 :style="{width:isView?'60%':'100%'}">
                <rcTable ref="rcTable"
                         :tableAttr="tableAttr"
                         :checkPms="hasPermission('CF0601')"
                         @onSelectChange="selectedChange">
                    <template slot="tootipL">
                        <Button v-if="hasPermission('CF0601')"
                                @click="refresh"
                                class="tootip-btn">
                            <i class="icon-refresh-o-2"></i>
                        </Button>
                        <Button v-if="hasPermission('CF0603')"
                                :disabled="!selected.length"
                                @click="readMsg()"
                                slot="tootipL">{{this.$t('标为已读')}}</Button>
                    </template>
                </rcTable>
            </div>
            <div class="detail-container"
                 :style="{width:isView?'40%':'0'}">
                <div class="content"
                     v-if="isView">
                    <div class="msg-header">{{$t('消息详情')}}
                        <Icon type="ios-close"
                              size="26"
                              class="pull-right close-icon"
                              @click="markRead" />
                    </div>
                    <div class="title">{{$t(crruentMsg.msgTitle)}}</div>
                    <div class="time">
                        <i class="icon-time-o"></i>&nbsp;&nbsp;<span>{{crruentMsg.sendDate}}</span>
                    </div>
                    <div class="msg-details-content"
                         v-html="crruentMsg.msgContent"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import helpInfo from '@c/basic/helpinfo'
import rcTable from '@/views/components/basic/rcTable'
import API from '@/service/api.js'
export default {
    name: 'MessageUnread',
    components: {
        helpInfo,
        rcTable
    },
    data () {
        return {
            helpData: {
                modelName: this.$t('未读消息')
            },
            isView: false,
            crruentMsg: {},
            markReadData: [],
            tabValue: 'unread',
            // 未读消息table
            selected: [],
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.GET_MSG_INFO, false),
                    params: {
                        readFlag: '02'
                    }
                },
                isMultiSelect: true,
                searchShow: false,
                referenceVal: 800,
                columns: [
                    {
                        title: this.$t('标题内容'),
                        key: 'msgTitle',
                        className: 'ellipsis',
                        resizable: true,
                        width: 300,
                        render: (h, params) => {
                            return h('a', {
                                class: !this.hasPermission('CF0602') ? 'disabled-per link' : 'link',
                                on: {
                                    click: () => {
                                        this.hasPermission('CF0602') && this.showDetail(params.row)
                                    }
                                }
                            }, this.$t(params.row.msgTitle))
                        }
                    },
                    {
                        title: this.$t('创建时间'),
                        key: 'sendDate',
                        className: 'ellipsis',
                        resizable: true,
                        minWidth: 150
                    },
                    {
                        title: this.$t('操作'),
                        width: 80,
                        fixed: 'right',
                        render: (h, params) => {
                            return h('div', { class: 'tbl-btn-div' }, [
                                h('a', {
                                    class: { 'disabled-per': !this.hasPermission('CF0603') },
                                    on: {
                                        click: () => { this.hasPermission('CF0603') && this.readMsg(params.row) }
                                    }
                                }, this.$t('标为已读'))
                            ])
                        }
                    }
                ]
            }
        }
    },
    created () {
    },
    methods: {
        showDetail (row) {
            if (!this.isView) {
                this.isView = true
            }
            this.crruentMsg = row
            // 记录所有看过的消息
            this.markReadData.push(row.msgSid)
        },
        // 未读消息列表选择
        selectedChange (rows) {
            this.selected = rows
        },
        // 刷新未读信息列表
        refresh () {
            this.$refs.rcTable && this.$refs.rcTable.refreshTable({ readFlag: '02' })
        },
        readMsg (row) {
            const params = row ? [row.msgSid] : this.selected.map(item => item.msgSid)
            if (!params.length) return
            this.$Modal.confirm({
                title: this.$t('请选择'),
                content: this.$t('您确认要将这') + '<span style="color:#ff6a01;font-weight:600">' + params.length + '</span>' + this.$t('条消息标记为已读吗？'),
                onOk: () => {
                    this.axios.put(this.urlFormat(API.PUT_MSG_READ, false), { ids: params }).then(res => {
                        this.refresh()
                    })
                }
            })
        },
        markRead () {
            if (!this.markReadData.length || !this.hasPermission('CF0603')) {
                this.isView = false
                return
            }
            this.axios.put(this.urlFormat(API.PUT_MSG_READ, false), { ids: this.markReadData }).then(res => {
                this.markReadData = []
                this.isView = false
                this.refresh()
            })
        }
    },
    beforeDestroy () {
        this.markRead(false)
    }
}
</script>

<style lang="less" scoped>
.unread-msg {
    display: flex;
    position: relative;
    height: calc(~'100% - 48px');
    width: 100%;
    .msg-table {
        padding: 15px;
        transition: width 0.4s;
        height: 100%;
    }
    .detail-container {
        height: 100%;
        transition: width 0.4s;
        .content {
            width: 100%;
            height: 100%;
            padding: 10px 20px 0 20px;
            border-left: 1px solid #e9e9e9;
            .msg-header {
                height: 30px;
                border-bottom: 1px dashed #e9e9e9;
                .close-icon:hover {
                    cursor: pointer;
                    color: #ff6a01;
                }
            }
            .title {
                width: 100%;
                height: 30px;
                margin-top: 20px;
                line-height: 30px;
                font-size: 16px;
                font-weight: 500;
                color: #999;
                text-align: center;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .time {
                width: 100%;
                height: 30px;
                line-height: 30px;
                font-size: 12px;
                font-weight: 300;
                text-align: center;
                color: #aaa;
                span {
                    position: relative;
                    top: -1px;
                }
            }
            .msg-details-content {
                margin-top: 20px;
                font-size: 12px;
                color: #808080;
            }
        }
    }
}
</style>
